import { z } from "zod";

const publicUrlSchema = z.string().url().nullable();

/**
 * Zod schema for user profile with image field.
 * Common schema used across multiple API endpoints.
 */
export const userProfileSchema = z.object({
  id: z.string(),
  name: z.string(),
  image: publicUrlSchema,
});

export type UserProfile = z.infer<typeof userProfileSchema>;

/**
 * Matches a non-negative decimal amount with up to 2 fractional digits.
 * Shared so the same precision contract holds across API input validation and
 * frontend field checks (numeric(12,2) columns surface as strings end to end).
 */
export const DECIMAL_AMOUNT_REGEX = /^\d+(\.\d{1,2})?$/;

export const decimalAmountSchema = z
  .string()
  .regex(
    DECIMAL_AMOUNT_REGEX,
    "Must be a non-negative amount with up to 2 decimals",
  );
